import type {Lang} from '@gravity-ui/uikit';

export const lang = document.documentElement.lang as Lang;
